const links = [
    {
      label: "Whatsapp",
      icon: "whatsapp",
      url: "https://api.whatsapp.com/send?phone=918376070107",
      hover_class: "wa-hover",
    },
    {
      label: "Facebook",
      icon: "facebook",
      url: "https://www.facebook.com/Padhakku-101993124589849/",
      hover_class: "fb-hover",
    },
    {
      label: "Instagram",
      icon: "instagram",
      url: "https://www.instagram.com/padhakku",
      hover_class: "ig-hover",
    },
    {
      label: "LinkedIn",
      icon: "linkedin",
      url: "https://www.linkedin.com/company/padhakku",
      hover_class: "ln-hover",
    },
    {
      label: "Youtube",
      icon: "youtube",
      url: "https://www.youtube.com/channel/UCELKwvzyO70lrLcZHBeqBwA",
      hover_class: "yt-hover",
    },
    {
      label: "Gmail",
      icon: "mail",
      url: "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=padhakku@gmail.com",
      hover_class: "email-hover",
    },
  ];
  
  export default links;